import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Language } from '@shared/interfaces/lang';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  public currentLang = new BehaviorSubject<string>('en');

  private languages: Language[] = [
    { languageName: 'English', languageCode: 'en' },
    { languageName: 'Française', languageCode: 'fr' },
    { languageName: 'Español', languageCode: 'es' },
    { languageName: 'Deutsche', languageCode: 'de' }
  ];
  private selectedLanguage: string | Language = 'en';

  constructor(private translateService: TranslateService, private http: HttpClient) {}

  public getLanguageList(): Language[] {
    return this.languages;
  }

  public getCurrentLanguage(): Language {
    return this.languages.find(l => l.languageCode === this.selectedLanguage);
  }

  public switchLanguage(newLang: any): void {
    let language;
    if (newLang.languageCode) {
      language = newLang.languageCode;
    } else {
      language = newLang;
    }

    this.selectedLanguage = language;
    this.translateService.use(language);
    this.currentLang.next(language);
  }

  loadTranslationFile(translationFilePath: string, shouldMerge: boolean = false) {
    return this.http.get(translationFilePath).pipe(
      map((translations: any) => {
        this.translateService.setTranslation(this.currentLang.value, translations, shouldMerge);
      })
    );
  }

  public applyCurrentLanguage(instance?: any) {
    // setTimeout(() => {
    //   // const _instance = instance || this.translateService;
    //   // _instance.currentLang = '';
    //   // _instance.setDefaultLang(this.getCurrentLanguage().languageCode);
    //   // _instance.use(this.getCurrentLanguage().languageCode);
    //   // _instance.reloadLang(this.getCurrentLanguage().languageCode).subscribe(()=> {
    //   //   _instance.currentLang = '';
    //   //   _instance.setDefaultLang(this.getCurrentLanguage().languageCode);
    //   //   _instance.use(this.getCurrentLanguage().languageCode);
    //   // });
    // });
  }
}
